import { render, staticRenderFns } from "./TopicFormAlert.vue?vue&type=template&id=05525a30"
import script from "./TopicFormAlert.vue?vue&type=script&lang=ts"
export * from "./TopicFormAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports